import { CacheProvider } from '@emotion/react'

import { ThemeProvider } from '@mui/material'
import createCache from '@emotion/cache'
import theme from '../theme/default'

function createEmotionCache() {
  return createCache({ key: 'css' })
}

// This helps with hydration issues where the CSS sometimes doesn't load in time
export function MuiProvider({ children }: { children: React.ReactNode }) {
  const cache = createEmotionCache()

  return (
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme} defaultMode='light'>
        {children}
      </ThemeProvider>
    </CacheProvider>
  )
}